var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table-column',{attrs:{"align":"left","label":"Город и Область"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('h4',[_vm._v(_vm._s(scope.row.city.name))]),_c('div',[_vm._v(_vm._s(scope.row.city.region_name))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }